import { colors } from 'fitify-ui'
import Careers from 'fitify-ui-landing/src/components/blocks/Careers/Careers'
import Section from 'fitify-ui-landing/src/components/Section/Section'
import type { NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import Container from '@/components/Container/Container'
import { Layout } from '@/components/layouts/Layout'
import { getStaticPropsTranslations } from '@/utils/i18n'

const CareersPage: NextPage = () => {
  const { t } = useTranslation()

  return (
    <Layout
      seo={{
        title: 'Careers | Nutria',
        description: t('cl_landing_carrers_meta_description'),
      }}
    >
      <Section style={{ background: colors.Mantis100 }}>
        <Container
          style={{
            padding: '1.5rem 0',
            marginTop: '2rem',
            marginBottom: '2rem',
            background: 'white',
          }}
        >
          <Careers />
        </Container>
      </Section>
    </Layout>
  )
}

export default CareersPage

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await getStaticPropsTranslations(locale)),
    },
  }
}
